import Dexie from 'dexie'
import { _, action, observable, autorun, reaction, toJS, stringify } from '@api';
import {CatalogStore, configs, globalStores} from '@stores'

export interface IOfflineCatalogItem {
  id?: number
  index: string
  data: any
}


export class OfflineCatalogItemDatabase extends Dexie {
  constructor() {
    super(`vip-offline-catalog-${globalStores.es.clientUrl}`);
    this.version(1).stores({
      'items': '++id, index, data'
    })

    this.offlineItems = this.table("items");
  }

  offlineItems: Dexie.Table<IOfflineCatalogItem, number>;

  @action recursivelyRemoveDexieUnserializableFields = (obj) => {
    let result = obj

    if (!result) return result

    Object.keys(result).forEach(key => {
      if (key == '__parent' || key == '__path' || typeof obj[key] === 'function') {
        delete result[key]
      } else if (result[key] && _.isArray(obj[key])) {
        result[key] = obj[key].map(v => this.recursivelyRemoveDexieUnserializableFields(v))
      } else if (result[key] && typeof obj[key] === 'object') this.recursivelyRemoveDexieUnserializableFields(result[key])
    })
    return result
  }

  @action deleteItem = async (offlineId : string) => {
    const {offlineItemsMap} = globalStores.catalog

    const offlineItem = offlineItemsMap[offlineId]
    delete offlineItemsMap[offlineId]
    offlineItem.dispose()
    await this.offlineItems.delete(offlineItem.item.id)
  }

  deleteItems = async (offlineIds: Array<string>) => {
    await Promise.all(offlineIds.map(this.deleteItem))
  }
}

export class OfflineItemWrapper {
  @observable item : IOfflineCatalogItem = null

  firstWatch = true
  autorun_watchForChanges = () => autorun(() => {
    const v = stringify(this.item ?? {})
    const {item, item: {id}} = this

    if (this.firstWatch) this.firstWatch = false
    else {
      // console.log(`Pending Item modified`, toJS(item))
      // Todo - this could just be the changes instead of the whole object
      this.catalog.offlineItemsDb.offlineItems.update(id, toJS(this.item))
    }
  })

  constructor(public catalog: CatalogStore, item: IOfflineCatalogItem) {
    this.item = item

    // Hack due to bad Pending Items data
    if (_.isBoolean(this.item?.data?.images)) {
      this.item.data.images = []
    }
  }

  registerEffects = () => {
    // Automatically persist changes to Pending Items to our indexed db
    this._toDispose = [
      this.autorun_watchForChanges()
    ]
  }


  private _toDispose = []
  @action dispose = () => {
    this._toDispose.forEach(f => f())
  }

}

export const OFFLINE_ID = 'OFFLINE!'
export const isOfflineId = (id: string) => {
  if (!_.isString(id)) {
    return false
  }
  return id != null && id.startsWith(OFFLINE_ID)
}



// WEBPACK FOOTER //
// ./src/stores/catalog/OfflineCatalogItems.ts